import type { App } from "@dfds-activity-map/api/server";
import { treaty } from "@elysia/eden";
import { ENV } from "varlock/env";

const { api } = treaty<App>(ENV.VITE_API_URL, { fetch: { credentials: "include" } });

export { api };
